import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { isNil, find as _find, isEmpty, capitalize, filter } from "lodash"
import context from "../context"
import { compose } from "recompose"
import { withStyles } from "@material-ui/styles"
import { pickersTheme } from "../../../themes/main"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import LoadingButton from "../../../components/LoadingButton"
import AddIcon from "@material-ui/icons/Add"
import Input from "@material-ui/core/Input"
import { MuiThemeProvider } from "@material-ui/core/styles"
// import ShootDetailsCrewCard from "../../../components/ShootDetailsCrewCard/index"
import CrewSlate from "../../../components/CrewSlate/index"
import { Add, Close } from "@material-ui/icons"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"
import Image from "../../../assets/images/login_bg.jpg"
import SelectCrew from "../../../components/SelectCrew"
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Paper,
  Box,
  TextField,
  Typography,
  Chip,
  Tooltip,
  Switch,
  Divider,
  Avatar,
  Icon,
  Popover,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Hidden,
  Button,
  IconButton,
  CircularProgress,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Modal,
} from "@material-ui/core"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import { formatMoney } from "accounting"
import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers"
import DateFnsUtils from "@date-io/date-fns"
import {
  updateShootRole,
  deleteShootGlue,
  createCalendars,
  createMasterCalendar,
  toggleShootDialog,
  toggleConfirmSaveShootDialog,
  setRoleForCrew,
  setActiveShootRole,
  deleteShootRoleFromShoots,
  getShootbyId,
  setCurrentShoot,
  recallShoot,
} from "../../../actions/shoots"
import {
  toggleCreateClientDialog,
  toggleCreateProducerDialog,
  toggleProfileDialog,
  toggleCreateUserDialog,
} from "../../../actions/users"

import { removeGigApplicationById } from "../../../actions/gigs"

import { clearCrewFromChip } from "../../../actions/crew"
import { openSnackBar } from "../../../actions/snack-bar"
import styles from "../styles"
import AutoComplete from "../../../components/AutoComplete"
import classNames from "classnames"
import update from "immutability-helper"
import AddressAutoComplete from "../../../components/AddressAutoComplete"
import moment from "../../../../node_modules/moment/moment"
import ChangeRateDialog from "../../../components/ChangeRateDialog/index"
import CrewCard from "../../../components/CrewCard/index"
import { getCurrentHost } from "../../../utils/getHost"
import {
  toggleAddClientCompanyDialog,
  getCompanyClients,
  getCompaniesByClient,
  toggleAddClientDialog,
} from "../../../actions/clients"
import {
  unattachUserToARole,
  unattachRoleToShoot,
  updateShootRole as updateShooRoleBilling,
} from "../../../actions/billing"
import AddClientDialog from "../../../components/AddClientDialog/index"
import { Link } from "react-router-dom"
import { primaryColor } from "../../../utils/color"

const locationVal = e => (e ? e + " " : "")

const requestedChip = (role, classes) => {
  // debugger;
  return (
    <Chip
      label={
        role.requested
          ? role.available
            ? "Confirmed"
            : "Requested"
          : "Not Requested"
      }
      style={{
        color: "white",
        marginTop: "8px",
      }}
      className={
        role.requested
          ? role.available
            ? classes.chipGreen
            : classes.chipYellow
          : classes.chipRed
      }
    />
  )
}

class Two extends Component {
  state = {
    equipment: null,
    client: null,
    additionalEquipment: [],
    anchorEl: null,
    switch: false,
    tbd: false,
    anchorId: null,
    changeRateOpen: false,
    editingRole: {},
    newRoleRate: "",
    savingRoleRate: false,
    percentage: 12,
    clientRate: 0,
    crewRate: 0,
    newShootField: "",
    savingNewShootField: false,
    expanded: null,
    equipmentAnchor: null,
    vehicleAnchor: null,
    deleteCrew: false,
    roleIndex: null,
  }

  handleNewShootFieldChange = e => {
    const value = e.target.value
    this.setState(
      update(this.state, {
        newShootField: {
          $set: value,
        },
      })
    )
  }

  saveNewShootField = () => {
    const { context, props } = this
    const { updateShootState } = props
    const { newShootField } = this.state

    this.setState({ savingNewShootFlied: true })
    let shoot = context.shoot
    let companyShootFields = shoot.company_shoot_fields
      ? JSON.parse(shoot.company_shoot_fields)
      : {}

    let flag = 0
    !isEmpty(companyShootFields) &&
      Object.getOwnPropertyNames(companyShootFields).forEach(key => {
        if (newShootField.toLowerCase() === key.toLowerCase()) {
          flag = 1
        }
      })

    if (flag === 1) {
      this.props.dispatch(
        openSnackBar({ message: "Shoot Field Already Exists" })
      )
      this.setState({ savingNewShootFlied: false })
      return
    } else {
      companyShootFields[newShootField] = null
      updateShootState(
        update(context, {
          shoot: {
            company_shoot_fields: {
              $set: JSON.stringify(companyShootFields),
            },
          },
        })
      )

      this.setState({ savingNewShootFlied: false, newShootField: "" })
    }
  }

  componentDidMount() {
    const shoot = this.context.shoot
    // debugger

    if (
      shoot.start_date &&
      shoot.end_date &&
      shoot.start_date.toISOString &&
      shoot.start_date.toISOString() !== shoot.end_date.toISOString()
    ) {
      this.setState({ switch: true })
    }
    if (isNil(shoot.call_time)) {
      this.setState({ tbd: true })
    }
    this.props.setSelectUser(this.selectUser)
    this.props.dispatch(getCompanyClients(shoot.client_company))
  }

  handleDateChange = (date, key) => {
    const { context, props } = this
    const { updateShootState } = props
    if (typeof key === "object") {
      if (context.shoot.end_date <= date && this.state.switch) {
        let nextDay = moment(date)
          .add(1, "days")
          .toDate()
        updateShootState(
          update(context, {
            shoot: {
              [key[0]]: {
                $set: date,
              },
              [key[1]]: {
                $set: new Date(new Date(nextDay).toGMTString()),
              },
            },
          })
        )
      } else {
        updateShootState(
          update(context, {
            shoot: {
              [key[0]]: {
                $set: date,
              },
              [key[1]]: {
                $set: date,
              },
            },
          })
        )
      }
    } else {
      updateShootState(
        update(context, {
          shoot: {
            [key]: {
              $set: date,
            },
          },
        })
      )
    }
  }

  handleTimeChange = date => {
    const { context, props } = this
    const { updateShootState } = props

    const time = date.toTimeString().split(" ")[0]

    updateShootState(
      update(context, {
        shoot: {
          call_time: {
            $set: time,
          },
        },
      })
    )
  }

  handleTbdChange = bool => {
    this.setState({ tbd: bool })
    const { context, props } = this
    const { updateShootState } = props
    const time = bool ? null : moment().format("YYYY-MM-DD HH:mm:00")
    updateShootState(
      update(context, {
        shoot: {
          call_time: {
            $set: time,
          },
        },
      })
    )
  }

  selectClient = client => {
    const { context, props } = this
    const { updateShootState } = props
    const { users } = context
    if (typeof client === "object" && typeof client.id === "number") {
      const newState = context
      newState.shoot.client = users[users.findIndex(x => x.id === client)]
      newState.shoot.client_id = users[users.findIndex(x => x.id === client).id]
      updateShootState(newState)
    } else {
      this.props.dispatch(toggleCreateClientDialog(true, {}))
      updateShootState(
        update(context, {
          shoot: {
            client: { $set: client },
          },
        })
      )
    }
    document.getElementById("shoot-location").focus()
  }

  selectProducer = producer => {
    const { context, props } = this
    const { updateShootState } = props
    const { users } = context
    if (typeof producer.id === "number") {
      const newState = context
      newState.shoot.producer =
        users[users.findIndex(x => x.id === producer.id)]
      updateShootState(newState)
    } else {
      this.props.dispatch(toggleCreateProducerDialog(true, {}))
      updateShootState(
        update(context, {
          shoot: {
            producer: { $set: producer.id },
          },
        })
      )
    }
    // document.getElementById("shoot-location").focus()
  }

  onAutoCompleteChange = val => {
    const { props, context } = this
    const { updateShootState } = props
    const { equipment } = context
    const eq = equipment.find(x => x.id === val)
    updateShootState(
      update(context, {
        shoot: {
          equipment: {
            $push: [eq],
          },
        },
      })
    )
  }

  handleChange = (e, name) => {
    const { context, props } = this
    const { updateShootState } = props
    updateShootState(
      update(context, {
        shoot: {
          [name]: {
            $set: e.target ? e.target.value : e,
          },
        },
      })
    )
  }

  handleCompanyShootFieldChange = (e, fieldName) => {
    const { context, props } = this
    const { updateShootState } = props

    let companyShootDetailFields = JSON.parse(
      context.shoot.company_shoot_fields
    )
    companyShootDetailFields[fieldName] = e.target ? e.target.value : e

    updateShootState(
      update(context, {
        shoot: {
          company_shoot_fields: {
            $set: JSON.stringify(companyShootDetailFields),
          },
        },
      })
    )
  }

  deleteShootField = (e, fieldName) => {
    const { context, props } = this
    const { updateShootState } = props

    let companyShootDetailFields = JSON.parse(
      context.shoot.company_shoot_fields
    )
    delete companyShootDetailFields[fieldName]

    updateShootState(
      update(context, {
        shoot: {
          company_shoot_fields: {
            $set: JSON.stringify(companyShootDetailFields),
          },
        },
      })
    )
  }

  setPopover = (e, func) => {
    this.props.setState(
      update(this.context, {
        popover: {
          anchor: {
            $set: e.currentTarget,
          },
          func: {
            $set: func,
          },
        },
      })
    )
  }

  clearFields = () => {
    this.setState({
      percentage: 12,
      clientRate: 0,
      crewRate: 0,
    })
  }

  selectUser = (user, role, bool, roleIndex) => {
    this.setState({ deleteCrew: true, roleIndex })

    let result = null
    if ((user && typeof user === "number") || bool) {
      this.context
        .dispatch(
          updateShootRole(this.context.shoot.id, role.id, {
            user_id: user,
          })
        )
        .then(res => {
          result = res
          return Promise.all([
            this.context.dispatch(createCalendars(this.context.shoot.id)),
            this.context.dispatch(createMasterCalendar(this.context.shoot.id)),
          ])
        })
        .then(res => {
          // this.props.setState({
          //   shoot: { ...this.context.shoot, roles: result.roles },
          // })
          // let shootId = window.location.pathname.match(/\d+/g).map(Number)

          // this.props.dispatch(getShootbyId(shootId)).then(() => {
          //   this.setState({ deleteCrew: false, roleIndex: null })
          // })

          this.props.dispatch(recallShoot(true))
          setTimeout(() => {
            this.props.dispatch(recallShoot(false))
          }, 800)

          //delete user from usersroles in redux
          if (bool) {
            this.props.dispatch(unattachUserToARole(role.id))
          }

          // window.location.reload()
        })
    } else {
      this.props.setState({ currentUpdateRole: role })
      this.context.dispatch(toggleCreateUserDialog(true, {}))
    }
  }

  updateShoorRoleData = (role, data) => {
    let newRes = null
    this.context
      .dispatch(updateShootRole(this.context.shoot.id, role.id, data))
      .then(res => {
        newRes = res
        return Promise.all([
          this.context.dispatch(createCalendars(this.context.shoot.id)),
          this.context.dispatch(createMasterCalendar(this.context.shoot.id)),
        ])
      })
      .then(res => {
        this.props.setState(
          update(
            {
              shoot: this.context.shoot,
            },
            {
              shoot: {
                $set: newRes,
              },
            }
          )
        )
        //update billing state in redux
        let dataToUpdate
        if (data.available) {
          dataToUpdate = {
            available: 1,
            requested: 1,
            user_status: "available",
          }
        } else {
          dataToUpdate = { available: 0, requested: 0, user_status: "unsent" }
        }
        this.context.dispatch(updateShooRoleBilling(role.id, dataToUpdate))
      })
  }

  changeRate = role => {
    this.setState({
      savingRoleRate: true,
    })
    this.context
      .dispatch(
        updateShootRole(this.context.shoot.id, this.state.editingRole.id, {
          client_rate: this.state.clientRate,
          crew_rate: this.state.crewRate,
        })
      )
      .then(res => {
        this.props.setState(
          update(
            {
              shoot: this.context.shoot,
            },
            {
              shoot: {
                $set: res,
              },
            }
          )
        )
        this.setState({
          savingRoleRate: false,
          changeRateOpen: false,
          crewRate: 0,
          clientRate: 0,
          percentage: 12,
        })
      })
  }

  handleCloseChangeRate = () => {
    this.setState({ changeRateOpen: false })
    this.clearFields()
  }

  openDialog = (shootId, role) => {
    this.props.dispatch(clearCrewFromChip())
    this.props.dispatch(setRoleForCrew(role))

    // to save the role
    this.props.dispatch(setActiveShootRole(role.id))

    // to empty the role
    // this.props.dispatch(setActiveShootRole())

    this.props.dispatch(toggleShootDialog({ open: true, id: shootId }))
  }

  openConfirmSave = role => {
    this.props.dispatch(setRoleForCrew(role))
    this.props.dispatch(toggleConfirmSaveShootDialog(true))
  }

  removeApplication = async (gigId, gigIndex) => {
    const { shoot } = this.context

    let shootGigApplications = shoot.shoots

    shootGigApplications.splice(gigIndex, 1)

    const response = await this.props.dispatch(removeGigApplicationById(gigId))
    if (
      response &&
      response.message &&
      response.message === "gig application deleted"
    ) {
      this.props.setState(
        update(
          {
            shoot: this.context.shoot,
          },
          {
            shoot: {
              shoots: {
                $set: shootGigApplications,
              },
            },
          }
        )
      )
      this.props.dispatch(openSnackBar({ message: response.message }))
    } else {
      this.props.dispatch(openSnackBar({ message: "Error Removing the Gig" }))
    }
  }

  addApplicantToRole = async (userId, role, bool, gigId, userIndex) => {
    await this.props.setState(
      update(
        {
          working: this.context.working,
        },
        {
          working: {
            $set: true,
          },
        }
      )
    )
    await Promise.all([
      this.selectUser(userId, role, bool),
      this.removeApplication(gigId, userIndex),
    ])
    await this.props.setState(
      update(
        {
          working: this.context.working,
        },
        {
          working: {
            $set: false,
          },
        }
      )
    )
  }

  handleApplicantExpansion = expandId => {
    this.setState({
      expanded: this.state.expanded === expandId ? null : expandId,
    })
  }

  handlePopoverOpen = (name, event) => {
    this.setState({ [`${name}Anchor`]: event.target })
  }

  handlePopoverClose = name => {
    this.setState({ [`${name}Anchor`]: null })
  }

  selectAndAddCompany = company => {
    const { props, context } = this
    const { updateShootState } = props

    if (company) {
      if (typeof company === "number") {
        updateShootState(
          update(context, {
            shoot: {
              client_company: { $set: company },
            },
          })
        )
      } else {
        this.props.dispatch(toggleAddClientCompanyDialog(true))
      }
    } else {
      updateShootState(
        update(context, {
          shoot: {
            client_company: { $set: null },
          },
        })
      )
    }
  }

  selectAndAddCompanyClient = client => {
    const { props, context } = this
    const { updateShootState } = props
    if (client && typeof client === "number") {
      updateShootState(
        update(context, {
          shoot: {
            company_user_id: { $set: client },
          },
        })
      )
    } else if (client && typeof client !== "number") {
      this.props.dispatch(toggleAddClientDialog(true))
    } else {
      updateShootState(
        update(context, {
          shoot: {
            company_user_id: { $set: null },
          },
        })
      )
    }
  }

  render() {
    const { context } = this
    const { shoot, users, equipment, dirty } = context

    const {
      classes,
      updateShootState,
      createdClient,
      createdProducer,
      companyList,
      createdCompany,
      companyClients,
      clientList,
    } = this.props

    const {
      anchorEl,
      anchorId,
      changeRateOpen,
      savingRoleRate,
      expanded,
      equipmentAnchor,
      vehicleAnchor,
    } = this.state
    const equipmentOpen = !!equipmentAnchor
    const vehicleOpen = !!vehicleAnchor

    const clientCompany =
      !isEmpty(companyList) && shoot && shoot.client_company
        ? companyList.find(cl => cl.id === shoot.client_company)
        : null
    const foundCompanyClient =
      !isEmpty(clientList) && shoot && shoot.company_user_id
        ? clientList.find(ccl => ccl.id === shoot.company_user_id)
        : null
    const companyClient = foundCompanyClient
      ? {
          id: foundCompanyClient.id,
          name:
            foundCompanyClient.first_name + " " + foundCompanyClient.last_name,
        }
      : null

    return (
      <Fragment>
        <AddClientDialog />

        <Grid container spacing={2}>
          <Grid item sm={10} md={5} className={classes.basicInfoWrapper}>
            <Card className={classes.card}>
              <CardHeader
                title="Basic Information"
                style={{
                  textAlign: "left",
                  backgroundColor:
                    getCurrentHost() === "crewmama" ? "#F04031" : "#5241a3",
                  color: "white",
                }}
              />
              <Divider />
              <CardContent>
                {/* WEB VIEW */}

                {/* <div style={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    className={classNames("", {
                      [classes.selectedDay]: !this.state.switch,
                      [classes.unselectedDay]: this.state.switch,
                    })}
                  >
                    Single Day
                  </Typography>
                  <Switch
                    checked={this.state.switch}
                    onChange={e => {
                      // change back to single day shoot
                      if (this.state.switch) {
                        updateShootState(
                          update(context, {
                            shoot: {
                              end_date: { $set: context.shoot.start_date },
                            },
                          })
                        )
                      }
                      this.setState({ switch: !this.state.switch })
                    }}
                  />
                  <Typography
                    className={classNames("", {
                      [classes.selectedDay]: this.state.switch,
                      [classes.unselectedDay]: !this.state.switch,
                    })}
                  >
                    Multi Day
                  </Typography>
                </div> */}

                <Hidden smDown>
                  {/* WEB VEIW */}
                  {/* date picker */}
                  <div style={{ display: "flex", marginBottom: "20px" }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <MuiThemeProvider theme={pickersTheme}>
                        <Grid container spacing={2}>
                          <Grid item sm={4}>
                            <DatePicker
                              style={{ width: "100%" }}
                              autoOk
                              inputVariant="outlined"
                              label="Start Date"
                              format="MM/dd/yyyy"
                              value={shoot.start_date}
                              onChange={e => {
                                this.handleDateChange(e, [
                                  "start_date",
                                  "end_date",
                                ])
                              }}
                              minDateMessage={`Start date should not be in the past`}
                            />
                          </Grid>
                          <Grid item sm={2}>
                            <TimePicker
                              margin="normal"
                              // label="Time picker"
                              format={"HH:mm:ss"}
                              value={shoot.call_time}
                              onChange={this.handleTimeChange}
                            />
                          </Grid>
                          <Grid item sm={1}>
                            <Typography style={{ paddingTop: "25px" }}>
                              to
                            </Typography>
                          </Grid>
                          <Grid item sm={2}>
                            <TimePicker
                              margin="normal"
                              // label="Time picker"
                              format={"HH:mm:ss"}
                              value={shoot.call_time}
                              onChange={this.handleTimeChange}
                            />
                          </Grid>
                          <Grid item sm={2}>
                            <div className={classes.timezonePickerBasic}>
                              <div
                                style={{
                                  fontSize: "12px",
                                  cursor: "pointer",
                                }}
                                onClick={e =>
                                  this.setState({ anchorEl: e.currentTarget })
                                }
                              >
                                {shoot.timezone}
                              </div>
                            </div>
                          </Grid>
                          {this.state.switch ? (
                            <Grid item sm={4}>
                              <DatePicker
                                style={{ width: "100%" }}
                                minDate={shoot.start_date}
                                autoOk
                                inputVariant="outlined"
                                label="End Date"
                                format="MM/dd/yyyy"
                                value={
                                  typeof shoot.end_date === "string"
                                    ? new Date(
                                        new Date(shoot.end_date).toGMTString()
                                      )
                                    : new Date(shoot.end_date.toGMTString())
                                }
                                onChange={e =>
                                  this.handleDateChange(e, "end_date")
                                }
                                minDateMessage={`End date should not be before the start date`}
                                allowKeyboardControl={false}
                              />
                            </Grid>
                          ) : (
                            <Grid item sm={4} />
                          )}

                          <Grid item sm={5}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                className={classNames("", {
                                  [classes.selectedDay]: !this.state.switch,
                                  [classes.unselectedDay]: this.state.switch,
                                })}
                              >
                                Single Day
                              </Typography>
                              <Switch
                                color="primary"
                                checked={this.state.switch}
                                onChange={e => {
                                  // change back to single day shoot
                                  if (this.state.switch) {
                                    updateShootState(
                                      update(context, {
                                        shoot: {
                                          end_date: {
                                            $set: context.shoot.start_date,
                                          },
                                        },
                                      })
                                    )
                                  } else {
                                    updateShootState(
                                      update(context, {
                                        shoot: {
                                          end_date: {
                                            $set: moment(
                                              context.shoot.start_date
                                            )
                                              .add(1, "days")
                                              .toDate(),
                                          },
                                        },
                                      })
                                    )
                                  }
                                  this.setState({
                                    switch: !this.state.switch,
                                  })
                                }}
                              />
                              <Typography
                                className={classNames("", {
                                  [classes.selectedDay]: this.state.switch,
                                  [classes.unselectedDay]: !this.state.switch,
                                })}
                              >
                                Multi Day
                              </Typography>
                            </div>
                          </Grid>

                          <Grid item sm={3}>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-end",
                                paddingTop: "7px",
                              }}
                            >
                              <Typography
                                variant="body1"
                                style={
                                  this.state.tbd
                                    ? { fontWeight: "bold" }
                                    : { color: "#808080" }
                                }
                              >
                                Time TBD
                              </Typography>
                              <Checkbox
                                checked={this.state.tbd}
                                onChange={() =>
                                  this.handleTbdChange(!this.state.tbd)
                                }
                                value="checkedB"
                                color="primary"
                                inputProps={{
                                  "aria-label": "time to be determined",
                                }}
                                style={{ padding: 0, paddingLeft: 15 }}
                              />
                            </div>
                          </Grid>
                        </Grid>
                      </MuiThemeProvider>
                    </MuiPickersUtilsProvider>
                    {/* end date picker */}
                    {/* time picker */}

                    {/* end time picker */}
                  </div>
                </Hidden>

                <Hidden mdUp>
                  {/* MOBILE VEIW */}
                  {/* date picker */}
                  <div style={{ display: "flex", marginBottom: "20px" }}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <MuiThemeProvider theme={pickersTheme}>
                        <Grid container spacing={2}>
                          <Grid item sm={6}>
                            <DatePicker
                              style={{ width: "100%" }}
                              autoOk
                              inputVariant="outlined"
                              label="Start Date"
                              format="MM/dd/yyyy"
                              value={shoot.start_date}
                              onChange={e =>
                                this.handleDateChange(e, "start_date")
                              }
                              minDateMessage={`Start date should not be in the past`}
                            />
                          </Grid>
                          {this.state.switch ? (
                            <Grid item sm={6}>
                              <DatePicker
                                style={{ width: "100%" }}
                                minDate={shoot.start_date}
                                autoOk
                                inputVariant="outlined"
                                label="End Date"
                                format="MM/dd/yyyy"
                                value={
                                  typeof shoot.end_date === "string"
                                    ? new Date(
                                        new Date(shoot.end_date).toGMTString()
                                      )
                                    : new Date(shoot.end_date.toGMTString())
                                }
                                onChange={e =>
                                  this.handleDateChange(e, "end_date")
                                }
                                minDateMessage={`End date should not be before the start date`}
                                allowKeyboardControl={false}
                              />
                            </Grid>
                          ) : (
                            <Grid item sm={3} />
                          )}

                          <Grid item sm={5}>
                            <TimePicker
                              margin="normal"
                              // label="Time picker"
                              value={shoot.call_time}
                              onChange={this.handleTimeChange}
                            />
                          </Grid>
                          <Grid item sm={1}>
                            <Typography style={{ paddingTop: "25px" }}>
                              to
                            </Typography>
                          </Grid>
                          <Grid item sm={5}>
                            <TimePicker
                              margin="normal"
                              // label="Time picker"
                              value={shoot.call_time}
                              onChange={this.handleTimeChange}
                            />
                          </Grid>
                          <Grid item sm={2}>
                            <div className={classes.timezonePickerBasic}>
                              <div
                                style={{
                                  fontSize: "12px",
                                  cursor: "pointer",
                                }}
                                onClick={e =>
                                  this.setState({ anchorEl: e.currentTarget })
                                }
                              >
                                {shoot.timezone}
                              </div>
                            </div>
                          </Grid>

                          <Grid item sm={5}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                className={classNames("", {
                                  [classes.selectedDay]: !this.state.switch,
                                  [classes.unselectedDay]: this.state.switch,
                                })}
                              >
                                Single Day
                              </Typography>
                              <Switch
                                color="primary"
                                checked={this.state.switch}
                                onChange={e => {
                                  // change back to single day shoot
                                  if (this.state.switch) {
                                    updateShootState(
                                      update(context, {
                                        shoot: {
                                          end_date: {
                                            $set: context.shoot.start_date,
                                          },
                                        },
                                      })
                                    )
                                  }
                                  this.setState({
                                    switch: !this.state.switch,
                                  })
                                }}
                              />
                              <Typography
                                className={classNames("", {
                                  [classes.selectedDay]: this.state.switch,
                                  [classes.unselectedDay]: !this.state.switch,
                                })}
                              >
                                Multi Day
                              </Typography>
                            </div>
                          </Grid>

                          <Grid item sm={3}>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-end",
                                paddingTop: "7px",
                              }}
                            >
                              <Typography
                                variant="body1"
                                style={
                                  this.state.tbd
                                    ? { fontWeight: "bold" }
                                    : { color: "#808080" }
                                }
                              >
                                Time TBD
                              </Typography>
                              <Checkbox
                                checked={this.state.tbd}
                                onChange={() =>
                                  this.handleTbdChange(!this.state.tbd)
                                }
                                value="checkedB"
                                color="primary"
                                inputProps={{
                                  "aria-label": "time to be determined",
                                }}
                                style={{ padding: 0, paddingLeft: 15 }}
                              />
                            </div>
                          </Grid>
                        </Grid>
                      </MuiThemeProvider>
                    </MuiPickersUtilsProvider>
                    {/* end date picker */}
                    {/* time picker */}

                    {/* end time picker */}
                  </div>
                </Hidden>

                <Hidden smDown>
                  <Grid container spacing={4}>
                    <Grid item sm={12}>
                      {/* <AutoComplete
                        creatable
                        value={
                          isNil(createdClient) ? shoot.client : createdClient
                        }
                        showValue
                        placeholder="Client (user)"
                        onChange={this.selectClient}
                        labelKey="full_name"
                        formatCreateLabel={value => "Create new client"}
                        prop={context}
                      /> */}
                      <AddressAutoComplete
                        className={classes.locationAutoComplete}
                        value={
                          shoot.location &&
                          Object.keys(shoot.location).length > 0
                            ? `${locationVal(
                                shoot.location.street_number
                              )}${locationVal(
                                shoot.location.route
                              )}${locationVal(shoot.location.city).replace(
                                " ",
                                ", "
                              )}${locationVal(
                                shoot.location.state
                              )}${locationVal(shoot.location.zip).replace(
                                " ",
                                ""
                              )}`
                            : undefined
                        }
                        InputProps={{
                          label: "Shoot Location",
                          id: "shoot-location",
                        }}
                        onChange={e => this.handleChange(e, "location")}
                      />
                    </Grid>

                    {/* <Grid item sm={12}>

                      <AutoComplete
                        placeholder="Search Company(Optional)"
                        value={isNil(createdCompany) ? clientCompany && clientCompany : createdCompany}
                        onChange={(value) => this.selectAndAddCompany(value)}
                        labelKey="name"
                        showValue
                        creatable={this.props.activeCompany}
                        formatCreateLabel={value => `Create new company`}
                        prop={this.props}
                      />
                    </Grid>
                    {(companyClient || (!companyClient && !isEmpty(companyClients))) && (
                      <Grid item sm={12}>
                        <AutoComplete
                          placeholder="Select Company User"
                          value={companyClient}
                          onChange={(value) => this.selectAndAddCompanyClient(value)}
                          labelKey="name"
                          // creatable={this.props.activeCompany}
                          showValue
                          prop={this.props}
                        />
                      </Grid>
                    )} */}
                    <Grid item sm={12} style={{ marginTop: "10px" }}>
                      <AutoComplete
                        placeholder="Search Company"
                        value={clientCompany ? clientCompany : null}
                        onChange={value => this.selectAndAddCompany(value)}
                        labelKey="name"
                        blurInputOnSelect
                        backspaceRemovesValue
                        isClearable={true}
                        creatable={this.props.activeCompany}
                        showValue
                        formatCreateLabel={value => `Create new company`}
                        prop={this.props}
                      />
                    </Grid>
                    <Grid item sm={12} style={{ marginTop: "10px" }}>
                      <AutoComplete
                        placeholder="Search Company User"
                        value={companyClient}
                        onChange={value =>
                          this.selectAndAddCompanyClient(value)
                        }
                        creatable={this.props.activeCompany}
                        formatCreateLabel={value => `Create new company user`}
                        labelKey="name"
                        blurInputOnSelect
                        backspaceRemovesValue
                        isClearable={true}
                        showValue
                        prop={this.props}
                      />
                    </Grid>

                    <Grid item sm={12}>
                      <TextField
                        label="Shoot Description"
                        multiline
                        fullWidth
                        margin="normal"
                        value={shoot.forward_facing_text || ""}
                        onChange={e =>
                          this.handleChange(e, "forward_facing_text")
                        }
                      />
                    </Grid>
                    <Grid item sm={12}>
                      <TextField
                        label="Private Notes"
                        multiline
                        fullWidth
                        margin="normal"
                        value={shoot.creator_text || ""}
                        onChange={e => this.handleChange(e, "creator_text")}
                      />
                    </Grid>

                    {/* <Grid item sm={12}>
                      <AutoComplete
                        value={
                          createdProducer
                            ? createdProducer
                            : shoot.producer && !isNil(shoot.producer)
                              ? users.find(x => x.id === Number(shoot.producer))
                              : ""
                          // shoot.producer && typeof shoot.producer !== "object"
                          //   ? users.find(x => x.id === Number(shoot.producer))
                          //   : shoot.producer
                          //     ? shoot.producer
                          //     : null
                        }
                        showValue
                        placeholder="Producer (user)"
                        onChange={this.selectProducer}
                        suggestions={users}
                        labelKey="full_name"
                        creatable
                        formatCreateLabel={value => "Create new producer"}
                        prop={context}
                      />
                    </Grid>

                    <Grid item sm={12}>
                      <AutoComplete
                        className={classNames(
                          classes.autoComplete,
                          classes.marginRight
                        )}
                        caps
                        placeholder="Additional Equipment"
                        onChange={val => this.onAutoCompleteChange(val)}
                        suggestions={equipment}
                        labelKey="name"
                        prop={context}
                      />
                    </Grid> */}
                    <div style={{ marginBottom: "10px" }}>
                      {shoot.equipment &&
                        shoot.equipment.map((equipment, i) => {
                          return (
                            <Chip
                              key={equipment.id}
                              avatar={
                                <Avatar
                                  className={classes.closeAvatar}
                                  onClick={e => {
                                    updateShootState(
                                      update(context, {
                                        shoot: {
                                          equipment: {
                                            $splice: [[i, 1]],
                                          },
                                          remove_equipment: {
                                            $push: [equipment],
                                          },
                                        },
                                      })
                                    )
                                  }}
                                >
                                  <Icon className={classes.closeIcon}>
                                    close
                                  </Icon>
                                </Avatar>
                              }
                              label={equipment.name}
                              color="primary"
                              style={{
                                color: "white",
                                marginLeft: "8px",
                                marginTop: "8px",
                              }}
                            />
                          )
                        })}
                    </div>
                  </Grid>
                </Hidden>
                {/* MOBILE VIEW */}
                <Hidden mdUp>
                  <Grid
                    container
                    spacing={0}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Grid item sm={12}>
                      {/* <AutoComplete
                        value={
                          isNil(createdClient) ? shoot.client : createdClient
                        }
                        showValue
                        placeholder="Client (user)"
                        onChange={this.selectClient}
                        labelKey="full_name"
                        // suggestions={users}
                        creatable
                        formatCreateLabel={value => "Create new client"}
                        prop={context}
                      /> */}
                    </Grid>
                    <Grid item sm={12}>
                      <AddressAutoComplete
                        className={classes.locationAutoComplete}
                        value={
                          shoot.location &&
                          Object.keys(shoot.location).length > 0
                            ? `${locationVal(
                                shoot.location.street_number
                              )}${locationVal(
                                shoot.location.route
                              )}${locationVal(shoot.location.city).replace(
                                " ",
                                ", "
                              )}${locationVal(
                                shoot.location.state
                              )}${locationVal(shoot.location.zip).replace(
                                " ",
                                ""
                              )}`
                            : undefined
                        }
                        InputProps={{
                          label: "Shoot Location",
                          id: "shoot-location",
                        }}
                        onChange={e => this.handleChange(e, "location")}
                      />
                    </Grid>
                    {/* ToDo define companies and clients */}
                    {/* <Grid item sm={12} style={{ marginTop: "15px", marginBottom: "15px" }}>
                      <AutoComplete
                        placeholder="Search Company(Optional)"
                        value={isNil(createdCompany) ? clientCompany && clientCompany : createdCompany}
                        onChange={(value) => this.selectAndAddCompany(value)}
                        labelKey="name"
                        creatable={this.props.activeCompany}
                        formatCreateLabel={value => `Create new company`}
                        prop={this.props}
                      />
                     
                    </Grid> */}

                    {/* {(companyClient || (!companyClient && !isEmpty(companyClients))) && (
                      <Grid item sm={12} style={{ marginTop: "15px", marginBottom: "15px" }}>
                        <AutoComplete
                          placeholder="Select Company User"
                          value={companyClient}
                          onChange={(value) => this.selectAndAddCompanyClient(value)}
                          labelKey="name"
                          // creatable={this.props.activeCompany}
                          showValue
                          prop={this.props}
                        />
                      </Grid>
                    )} */}
                    <Grid item sm={12} style={{ marginTop: "10px" }}>
                      <AutoComplete
                        placeholder="Search Company"
                        value={clientCompany}
                        onChange={value => this.selectAndAddCompany(value)}
                        labelKey="name"
                        creatable={this.props.activeCompany}
                        formatCreateLabel={value => `Create new company`}
                        blurInputOnSelect
                        backspaceRemovesValue
                        isClearable={true}
                        showValue
                        prop={this.props}
                      />
                    </Grid>
                    <Grid item sm={12} style={{ marginTop: "10px" }}>
                      <AutoComplete
                        placeholder="Search Company User"
                        value={companyClient}
                        onChange={value =>
                          this.selectAndAddCompanyClient(value)
                        }
                        labelKey="name"
                        blurInputOnSelect
                        backspaceRemovesValue
                        isClearable={true}
                        showValue
                        prop={this.props}
                      />
                    </Grid>

                    {/* ToDo define companies and clients end*/}

                    <Grid item sm={6}>
                      <TextField
                        label="Shoot Description"
                        multiline
                        fullWidth
                        margin="normal"
                        value={shoot.forward_facing_text || ""}
                        onChange={e =>
                          this.handleChange(e, "forward_facing_text")
                        }
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        label="Private Notes"
                        multiline
                        fullWidth
                        margin="normal"
                        value={shoot.creator_text || ""}
                        onChange={e => this.handleChange(e, "creator_text")}
                      />
                    </Grid>

                    <Grid item sm={6}>
                      <AutoComplete
                        value={
                          createdProducer
                            ? createdProducer
                            : shoot.producer && !isNil(shoot.producer)
                              ? users.find(x => x.id === Number(shoot.producer))
                              : ""
                          // shoot.producer && typeof shoot.producer !== "object"
                          //   ? users.find(x => x.id === Number(shoot.producer))
                          //   : shoot.producer
                          //     ? shoot.producer
                          //     : null
                        }
                        showValue
                        placeholder="Producer (user)"
                        onChange={this.selectProducer}
                        suggestions={users}
                        labelKey="full_name"
                        creatable
                        formatCreateLabel={value => "Create new producer"}
                        prop={context}
                      />
                    </Grid>

                    <Grid item sm={6}>
                      <AutoComplete
                        className={classNames(
                          classes.autoComplete,
                          classes.marginRight
                        )}
                        caps
                        placeholder="Additional Equipment"
                        onChange={val => this.onAutoCompleteChange(val)}
                        suggestions={equipment}
                        labelKey="name"
                        prop={context}
                      />
                    </Grid>
                  </Grid>
                </Hidden>
                <Grid container spacing={2} />
              </CardContent>
            </Card>
          </Grid>
          <Grid item sm={10} md={3} className={classes.shootInfoWrapper}>
            <Card className={classes.card}>
              <CardHeader
                title="Shoot Information"
                style={{
                  textAlign: "left",
                  backgroundColor:
                    getCurrentHost() === "crewmama" ? "#F04031" : "#5241a3",
                  color: "white",
                }}
              />
              <Divider />
              <CardContent>
                {shoot.company_shoot_fields &&
                  Object.keys(JSON.parse(shoot.company_shoot_fields)).map(
                    key => (
                      <TextField
                        key={key}
                        fullWidth
                        margin="normal"
                        label={key}
                        value={
                          JSON.parse(shoot.company_shoot_fields)[key] || ""
                        }
                        onChange={e =>
                          this.handleCompanyShootFieldChange(e, key)
                        }
                        InputProps={{
                          endAdornment: (
                            <Tooltip placement="top" title="remove shoot field">
                              <IconButton
                                onClick={e => this.deleteShootField(e, key)}
                              >
                                <Icon>close</Icon>
                              </IconButton>
                            </Tooltip>
                          ),
                        }}
                      />
                    )
                  )}

                <Grid
                  container
                  className={classes.inputWithAddButton}
                  style={{ display: "flex", marginTop: "20px" }}
                >
                  <Grid
                    item
                    className={classes.newInputWrapper}
                    xs={12}
                    sm={11}
                  >
                    <FormControl fullWidth>
                      <InputLabel htmlFor="description">
                        New Shoot Field
                      </InputLabel>
                      <Input
                        fullWidth
                        classes={{
                          input: classes.input,
                        }}
                        name="newShootField"
                        value={this.state.newShootField}
                        onChange={this.handleNewShootFieldChange}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item className={classes.newInputWrapper} xs={12} sm={1}>
                    <LoadingButton
                      color="primary"
                      size="small"
                      buttonclicked={this.saveNewShootField}
                      working={this.state.savingNewShootFlied}
                      disabled={!this.state.newShootField}
                      type="button"
                    >
                      <AddIcon color="inherit" />
                    </LoadingButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid
            container
            spacing={2}
            direction="row"
            sm={4}
            className={classes.crewWrapper}
          >
            {shoot.roles.map((role, roleIndex) => {
              if (role.user_id) {
                const crew = context.crew.find(c => c.id === role.user_id)
                return crew ? (
                  <Grid item sm={12}>
                    <ChangeRateDialog
                      open={changeRateOpen}
                      handleCloseChangeRate={this.handleCloseChangeRate}
                      clientRate={this.state.clientRate}
                      crewRate={this.state.crewRate}
                      percentage={this.state.percentage}
                      setClientRate={e => this.setState({ clientRate: e })}
                      setCrewRate={e => this.setState({ crewRate: e })}
                      setPercentage={e => this.setState({ percentage: e })}
                      submit={this.changeRate}
                      submitting={savingRoleRate}
                      activeCompany={this.props.activeCompany}
                    />
                    <Grid container direction="row">
                      <div
                        data-id={crew.id}
                        className={this.props.classes.crewCardWrapper}
                      >
                        {/* WEB VIEW */}
                        <Hidden smDown>
                          <CrewSlate
                            crew={crew}
                            isPositionSearch={false}
                            currentUser={context.authenticatedUser}
                            bottomArea={e => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    flexGrow: 1,
                                  }}
                                >
                                  {/* <div
                                    className={classes.rateWrapper}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  > */}
                                  {/* <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Typography
                                        className={classes.rateHeadline}
                                      >
                                        {this.props.activeCompany
                                          ? "Client Rate"
                                          : "Crew Rate"}
                                      </Typography>
                                      <Typography className={classes.rate}>
                                        {formatMoney(role.client_rate, "$", 0)}
                                      </Typography>
                                    </div> */}
                                  {/* {this.props.activeCompany && (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          marginLeft: "8px",
                                        }}
                                      >
                                        <Typography
                                          className={classes.rateHeadline}
                                        >
                                          Crew Rate
                                        </Typography>
                                        <Typography className={classes.rate}>
                                          {formatMoney(role.crew_rate, "$", 0)}
                                        </Typography>
                                      </div>
                                    )} */}
                                  {/* <div style={{ display: "flex", flexDirection: "column", marginLeft: "8px" }}>
                                    <Typography
                                      
                                      className={classes.rateHeadline}
                                    >
                                      %
                                    </Typography>
                                    <Typography
                                      
                                      className={classes.rate}
                                    >
                                      {formatMoney(role.crew_rate, "$", 0)}
                                    </Typography>
                                  </div> */}
                                  {role.approved === 0 &&
                                    role.bill_accepted === 0 &&
                                    role.bill_requested === 0 && (
                                      <IconButton
                                        onClick={e =>
                                          this.setState({
                                            anchorEl: e.currentTarget,
                                            anchorId: role.id,
                                          })
                                        }
                                        style={{
                                          transform: "translate(20px, 0)",
                                          marginRight: "20px",
                                        }}
                                      >
                                        <Icon>more_vert</Icon>
                                      </IconButton>
                                    )}
                                  {/* </div> */}
                                  <Popover
                                    open={
                                      Boolean(anchorId) &&
                                      anchorId === role.id &&
                                      Boolean(anchorEl)
                                    }
                                    anchorEl={anchorEl}
                                    onClose={e => {
                                      this.setState({
                                        anchorEl: null,
                                        anchorId: null,
                                      })
                                    }}
                                    anchorOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                  >
                                    <List style={{ cursor: "pointer" }}>
                                      {!role.available ? (
                                        <React.Fragment>
                                          <ListItem
                                            onClick={e => {
                                              this.updateShoorRoleData(role, {
                                                available: true,
                                                requested: true,
                                              })
                                              this.setState({
                                                anchorEl: null,
                                                anchorId: null,
                                              })
                                            }}
                                          >
                                            <ListItemText>
                                              Mark as Confirmed
                                            </ListItemText>
                                          </ListItem>
                                        </React.Fragment>
                                      ) : (
                                        <ListItem
                                          onClick={e => {
                                            this.updateShoorRoleData(role, {
                                              requested: false,
                                              available: false,
                                            })
                                            this.setState({
                                              anchorEl: null,
                                              anchorId: null,
                                            })
                                          }}
                                        >
                                          <ListItemText>
                                            Mark as Not Requested
                                          </ListItemText>
                                        </ListItem>
                                      )}
                                    </List>
                                  </Popover>
                                  <Tooltip
                                    placement="top"
                                    title="remove crew member from shoot"
                                  >
                                    <LoadingButton
                                      onClick={e => {
                                        this.setPopover(
                                          e,
                                          bool =>
                                            bool
                                              ? this.selectUser(
                                                  null,
                                                  role,
                                                  true,
                                                  roleIndex
                                                )
                                              : ""
                                        )
                                      }}
                                      variant="contained"
                                      color="secondary"
                                      working={
                                        this.state.roleIndex === roleIndex &&
                                        this.state.deleteCrew
                                          ? true
                                          : false
                                      }
                                      // disabled={
                                      //   this.state.deleteCrew ? true : false
                                      // }
                                    >
                                      Cancel
                                    </LoadingButton>
                                  </Tooltip>
                                </div>
                              )
                            }}
                            topArea={e => {
                              return (
                                <div
                                  style={{
                                    position: "absolute",
                                    zIndex: 1,
                                    margin: "8px",
                                    textAlign: "left",
                                  }}
                                >
                                  {/* <Chip
                                  label={role.name}
                                  color="primary"
                                  style={{ color: "white", cursor: "pointer" }}
                                /> */}
                                  {/* <br /> */}
                                  {requestedChip(role, this.props.classes)}
                                </div>
                              )
                            }}
                            onOpenProfile={() =>
                              this.props.dispatch(
                                toggleProfileDialog(true, { id: crew.id })
                              )
                            }
                            roleHeadline={e => {
                              return (
                                <div>
                                  <Typography
                                    component="p"
                                    className={classes.positionText}
                                    // BELOW IS WHERE ROLE NAME SHOWS UP FOR OLD FRONT END
                                  >
                                    {role.name}
                                  </Typography>
                                </div>
                              )
                            }}
                          />
                        </Hidden>

                        {/* MOBILE VIEW */}
                        <Hidden mdUp>
                          <CrewCard
                            crew={crew}
                            isPositionSearch={false}
                            currentUser={context.authenticatedUser}
                            bottomArea={e => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    flexGrow: 1,
                                  }}
                                >
                                  <div
                                    className={classes.rateWrapper}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {/* <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Typography
                                        className={classes.rateHeadline}
                                      >
                                        {this.props.activeCompany
                                          ? "Client Rate"
                                          : "Crew Rate"}
                                      </Typography>
                                      <Typography className={classes.rate}>
                                        {formatMoney(role.client_rate, "$", 0)}
                                      </Typography>
                                    </div>

                                    {this.props.activeCompany && (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          marginLeft: "8px",
                                        }}
                                      >
                                        <Typography
                                          className={classes.rateHeadline}
                                        >
                                          Crew Rate
                                        </Typography>
                                        <Typography className={classes.rate}>
                                          {formatMoney(role.crew_rate, "$", 0)}
                                        </Typography>
                                      </div>
                                    )} */}
                                    {/* <div style={{ display: "flex", flexDirection: "column", marginLeft: "8px" }}>
                                    <Typography
                                      
                                      className={classes.rateHeadline}
                                    >
                                      %
                                    </Typography>
                                    <Typography
                                      
                                      className={classes.rate}
                                    >
                                      {formatMoney(role.crew_rate, "$", 0)}
                                    </Typography>
                                  </div> */}
                                    {role.approved === 0 &&
                                      role.bill_accepted === 0 &&
                                      role.bill_requested === 0 && (
                                        <IconButton
                                          onClick={e =>
                                            this.setState({
                                              anchorEl: e.currentTarget,
                                              anchorId: role.id,
                                            })
                                          }
                                          style={{
                                            margin: "20px",
                                            transform: "translate(20px, 0)",
                                          }}
                                        >
                                          <Icon>more_vert</Icon>
                                        </IconButton>
                                      )}
                                  </div>

                                  <Popover
                                    open={
                                      Boolean(anchorId) &&
                                      anchorId === role.id &&
                                      Boolean(anchorEl)
                                    }
                                    anchorEl={anchorEl}
                                    onClose={e => {
                                      this.setState({
                                        anchorEl: null,
                                        anchorId: null,
                                      })
                                    }}
                                    anchorOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                  >
                                    <List style={{ cursor: "pointer" }}>
                                      {!role.available ? (
                                        <React.Fragment>
                                          <ListItem
                                            onClick={e => {
                                              this.updateShoorRoleData(role, {
                                                available: true,
                                                requested: true,
                                              })
                                              this.setState({
                                                anchorEl: null,
                                                anchorId: null,
                                              })
                                            }}
                                          >
                                            <ListItemText>
                                              Mark as Confirmed
                                            </ListItemText>
                                          </ListItem>
                                        </React.Fragment>
                                      ) : (
                                        <ListItem
                                          onClick={e => {
                                            this.updateShoorRoleData(role, {
                                              requested: false,
                                              available: false,
                                            })
                                            this.setState({
                                              anchorEl: null,
                                              anchorId: null,
                                            })
                                          }}
                                        >
                                          <ListItemText>
                                            Mark as Not Requested
                                          </ListItemText>
                                        </ListItem>
                                      )}
                                    </List>
                                  </Popover>

                                  <Tooltip
                                    placement="top"
                                    title="remove crew member from shoot"
                                  >
                                    <Button
                                      onClick={e => {
                                        this.setPopover(
                                          e,
                                          bool =>
                                            bool
                                              ? this.selectUser(
                                                  null,
                                                  role,
                                                  true
                                                )
                                              : ""
                                        )
                                      }}
                                      variant="contained"
                                      color="secondary"
                                    >
                                      Cancel
                                    </Button>
                                  </Tooltip>
                                </div>
                              )
                            }}
                            topArea={e => {
                              return (
                                <div
                                  style={{
                                    position: "absolute",
                                    zIndex: 1,
                                    margin: "8px",
                                    textAlign: "left",
                                  }}
                                >
                                  {/* <Chip
                                  label={role.name}
                                  color="primary"
                                  style={{ color: "white", cursor: "pointer" }}
                                /> */}
                                  {/* <br /> */}
                                  {requestedChip(role, this.props.classes)}
                                </div>
                              )
                            }}
                            onOpenProfile={() =>
                              this.props.dispatch(
                                toggleProfileDialog(true, { id: crew.id })
                              )
                            }
                            roleHeadline={e => {
                              return (
                                <div>
                                  <Typography
                                    component="p"
                                    className={[
                                      this.props.classes.positionText,
                                    ]}
                                  >
                                    {role.name}
                                  </Typography>
                                </div>
                              )
                            }}
                          />
                        </Hidden>
                      </div>
                    </Grid>
                  </Grid>
                ) : (
                  <CircularProgress
                    style={{ margin: "100px" }}
                    key={roleIndex}
                  />
                )
              } else {
                return (
                  <Grid item sm={12} className={classes.postionSlide}>
                    <ExpansionPanel
                      className={classes.collapseStyles}
                      expanded={expanded === role.id}
                    >
                      <Paper
                        elevation={3}
                        style={{
                          padding: "10px",
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          height: "fit-content",
                          backgroundColor: "#fbe6aa",
                        }}
                        Key={`merge-role-${roleIndex + 1}`}
                      >
                        <Typography
                          component="p"
                          style={{
                            fontSize: "0.9em",
                            alignSelf: "center",
                            fontWeight: 500,
                          }}
                        >
                          {role.name}
                        </Typography>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginRight: "10px",
                          }}
                        >
                          {shoot.shoots &&
                            shoot.shoots.length > 0 &&
                            shoot.shoots.find(
                              s =>
                                s.role_id === role.role_id &&
                                s.position_id === role.id
                                  ? true
                                  : false
                            ) && (
                              <ExpansionPanelSummary
                                className={classes.collapseSummary}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                expandIcon={
                                  expanded === role.id ? (
                                    <ExpandLessIcon />
                                  ) : (
                                    <ExpandMoreIcon />
                                  )
                                }
                                onClick={() =>
                                  this.handleApplicantExpansion(role.id)
                                }
                              >
                                <Typography
                                  component="p"
                                  style={{
                                    width: "max-content",
                                    fontSize: "0.7em",
                                    alignSelf: "center",
                                    fontWeight: 600,
                                  }}
                                >
                                  {
                                    filter(
                                      shoot.shoots,
                                      s =>
                                        s.role_id === role.role_id &&
                                        s.position_id === role.id
                                    ).length
                                  }{" "}
                                  {filter(
                                    shoot.shoots,
                                    s =>
                                      s.role_id === role.role_id &&
                                      s.position_id === role.id
                                  ).length > 1
                                    ? "Applicants"
                                    : "Applicant"}
                                </Typography>
                              </ExpansionPanelSummary>
                            )}

                          <Tooltip title="Add Crew to Role" placement="top">
                            <IconButton
                              style={{
                                padding: 0,
                                marginLeft: "10px",
                                backgroundColor: "#d1b667",
                              }}
                              onClick={e =>
                                dirty
                                  ? this.openConfirmSave(role)
                                  : this.openDialog(shoot.id, role)
                              }
                            >
                              <Add style={{ color: "#ffffff" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Remove Role" placement="top">
                            <IconButton
                              style={{
                                padding: 0,
                                marginLeft: "5px",
                                backgroundColor: "#d1b667",
                              }}
                              onClick={e => {
                                this.setPopover(e, bool => {
                                  if (bool) {
                                    this.props.setState(
                                      update(this.context, {
                                        shoot: {
                                          roles: {
                                            $splice: [[roleIndex, 1]],
                                          },
                                        },
                                      })
                                    )
                                    this.props
                                      .dispatch(
                                        deleteShootGlue(
                                          shoot.id,
                                          role.id,
                                          "roles"
                                        )
                                      )
                                      .then(() => {
                                        this.props.dispatch(
                                          createCalendars(shoot.id)
                                        )
                                      })
                                    this.props.dispatch(
                                      deleteShootRoleFromShoots(
                                        shoot.id,
                                        role.user_id
                                      )
                                    )

                                    //delete role from users roles state in redux
                                    this.props.dispatch(
                                      unattachRoleToShoot(role.id)
                                    )
                                  }
                                })
                              }}
                            >
                              <Close style={{ color: "#ffffff" }} />
                            </IconButton>
                          </Tooltip>
                        </span>
                      </Paper>

                      <ExpansionPanelDetails
                        className={classes.collapseDetails}
                      >
                        {shoot.shoots &&
                          shoot.shoots.map((user, userIndex) => {
                            if (user.user_id && user.position_id === role.id) {
                              let gigRole = shoot.roles.find(
                                r =>
                                  r.role_id === user.role_id &&
                                  role.role_id === user.role_id &&
                                  user.position_id === r.id
                              )
                              let gigApplicant = context.crew.find(
                                c => c.id === user.user_id
                              )

                              if (
                                gigApplicant &&
                                gigRole &&
                                gigApplicant.id === user.user_id &&
                                gigRole.role_id === user.role_id
                              ) {
                                return (
                                  <Box
                                    component="div"
                                    m={1}
                                    className={classes.collapseDetailsContainer}
                                  >
                                    {gigApplicant && (
                                      <Box
                                        component="div"
                                        m={1}
                                        className={classes.collapseDetailsRow}
                                      >
                                        <Avatar
                                          src={
                                            !isEmpty(gigApplicant.profile_image)
                                              ? `https://res.cloudinary.com/adesk/image/upload/c_thumb,g_face:auto,z_0.7,h_170,w_300,fl_lossy,f_auto/v${
                                                  gigApplicant.profile_image
                                                    .version
                                                }/${
                                                  gigApplicant.profile_image
                                                    .public_id
                                                }.${
                                                  gigApplicant.profile_image
                                                    .format
                                                }`
                                              : Image
                                          }
                                        />

                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "baseline",
                                          }}
                                        >
                                          <Link
                                            to={`/${gigApplicant.id}`}
                                            style={{ textDecoration: "none" }}
                                          >
                                            <Typography
                                              style={{
                                                fontSize: "0.7em",
                                                fontWeight: 600,
                                                marginRight: "10px",
                                              }}
                                            >
                                              {gigApplicant &&
                                                gigApplicant.first_name +
                                                  " " +
                                                  gigApplicant.last_name}
                                            </Typography>
                                          </Link>
                                          <Typography
                                            style={{ fontSize: "0.8em" }}
                                          >
                                            {gigRole && gigRole.name
                                              ? gigRole.name
                                              : "NA"}
                                          </Typography>
                                        </div>

                                        {/* try area */}

                                        <div className={classes.icons}>
                                          <i
                                            onClick={() =>
                                              gigApplicant.video
                                                ? this.setState({
                                                    videoModalOpen: true,
                                                  })
                                                : false
                                            }
                                            className={classNames(
                                              "icon-reel",
                                              classes.icon,
                                              classes.reelIcon,
                                              classes.trigger,
                                              {
                                                [classes.iconDisabled]: !gigApplicant.video,
                                              }
                                            )}
                                          />
                                          <Modal
                                            aria-labelledby="simple-modal-title"
                                            aria-describedby="simple-modal-description"
                                            open={this.state.videoModalOpen}
                                            onClose={() =>
                                              this.setState({
                                                videoModalOpen: false,
                                              })
                                            }
                                          >
                                            <div className={classes.modal}>
                                              <div
                                                style={{
                                                  padding: "56.25% 0 0 0",
                                                  position: "relative",
                                                }}
                                              >
                                                <iframe
                                                  title="vimeo-player"
                                                  src={`https://player.vimeo.com/video/${
                                                    gigApplicant.video
                                                  }?title=0&byline=0&portrait=0`}
                                                  style={{
                                                    position: "absolute",
                                                    top: "0",
                                                    left: "0",
                                                    width: "100%",
                                                    height: "100%",
                                                  }}
                                                  frameBorder="0"
                                                />
                                              </div>
                                              <script src="https://player.vimeo.com/api/player.js" />
                                            </div>
                                          </Modal>
                                          <i
                                            className={classNames(
                                              "icon-box",
                                              classes.icon,
                                              classes.boxIcon,
                                              classes.trigger,
                                              {
                                                [classes.iconDisabled]:
                                                  gigApplicant.equipment
                                                    .length === 0,
                                              }
                                            )}
                                            onMouseOver={event =>
                                              gigApplicant.equipment.length > 0
                                                ? this.handlePopoverOpen(
                                                    "equipment",
                                                    event
                                                  )
                                                : false
                                            }
                                            onMouseOut={() =>
                                              this.handlePopoverClose(
                                                "equipment"
                                              )
                                            }
                                          />
                                          <Popover
                                            className={classes.popover}
                                            classes={{
                                              paper: classes.popoverPaper,
                                            }}
                                            open={equipmentOpen}
                                            anchorEl={equipmentAnchor}
                                            onClose={() =>
                                              this.handlePopoverClose(
                                                "equipment"
                                              )
                                            }
                                            anchorOrigin={{
                                              vertical: "center",
                                              horizontal: "right",
                                            }}
                                            transformOrigin={{
                                              vertical: "center",
                                              horizontal: "left",
                                            }}
                                            disableRestoreFocus
                                          >
                                            <Typography
                                              variant="h6"
                                              className={classes.popoverTitle}
                                            >
                                              Equipment
                                            </Typography>
                                            <List>
                                              {gigApplicant.equipment.map(
                                                equipment => (
                                                  <ListItem
                                                    key={equipment.id}
                                                    className={classes.listItem}
                                                  >
                                                    <ListItemText
                                                      disableTypography
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.listText
                                                        }
                                                      >
                                                        {equipment.name}
                                                      </Typography>
                                                    </ListItemText>
                                                  </ListItem>
                                                )
                                              )}
                                            </List>
                                          </Popover>
                                          <i
                                            className={classNames(
                                              "icon-vehicle",
                                              classes.icon,
                                              classes.vehicleIcon,
                                              classes.trigger,
                                              {
                                                [classes.iconDisabled]:
                                                  gigApplicant.vehicles
                                                    .length === 0,
                                              }
                                            )}
                                            onMouseOver={event =>
                                              gigApplicant.vehicles.length > 0
                                                ? this.handlePopoverOpen(
                                                    "vehicle",
                                                    event
                                                  )
                                                : false
                                            }
                                            onMouseOut={() =>
                                              this.handlePopoverClose("vehicle")
                                            }
                                          />
                                          <Popover
                                            className={classes.popover}
                                            classes={{
                                              paper: classes.popoverPaper,
                                            }}
                                            open={vehicleOpen}
                                            anchorEl={vehicleAnchor}
                                            onClose={() =>
                                              this.handlePopoverClose("vehicle")
                                            }
                                            anchorOrigin={{
                                              vertical: "center",
                                              horizontal: "right",
                                            }}
                                            transformOrigin={{
                                              vertical: "center",
                                              horizontal: "left",
                                            }}
                                            disableRestoreFocus
                                          >
                                            <Typography
                                              variant="h6"
                                              className={classes.popoverTitle}
                                            >
                                              Vehicles
                                            </Typography>
                                            <List>
                                              {gigApplicant.vehicles.map(
                                                vehicle => (
                                                  <ListItem
                                                    key={vehicle.id}
                                                    className={classes.listItem}
                                                  >
                                                    <ListItemText
                                                      disableTypography
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.listText
                                                        }
                                                      >
                                                        {capitalize(
                                                          vehicle.make
                                                        )}{" "}
                                                        {capitalize(
                                                          vehicle.model
                                                        )}{" "}
                                                        {vehicle.year}
                                                      </Typography>
                                                    </ListItemText>
                                                  </ListItem>
                                                )
                                              )}
                                            </List>
                                          </Popover>
                                        </div>

                                        {/* try area end */}

                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          {/* <Tooltip
                                          placement="top"
                                          title={"this will add the member to role"}
                                        > */}
                                          <div>
                                            <Button
                                              color="primary"
                                              onClick={e => {
                                                dirty
                                                  ? this.this.props.dispatch(
                                                      toggleConfirmSaveShootDialog(
                                                        true
                                                      )
                                                    )
                                                  : this.addApplicantToRole(
                                                      user.user_id,
                                                      gigRole,
                                                      true,
                                                      user.gig_id,
                                                      userIndex
                                                    )
                                              }}
                                              variant="contained"
                                              size="small"
                                            >
                                              Book
                                            </Button>
                                          </div>
                                          {/* </Tooltip> */}

                                          <Tooltip
                                            placement="top"
                                            title={
                                              "this will delete the member application"
                                            }
                                          >
                                            <div>
                                              <IconButton
                                                onClick={e => {
                                                  dirty
                                                    ? this.this.props.dispatch(
                                                        toggleConfirmSaveShootDialog(
                                                          true
                                                        )
                                                      )
                                                    : this.removeApplication(
                                                        user.gig_id,
                                                        userIndex
                                                      )
                                                }}
                                              >
                                                <Close
                                                  className={classes.iconButton}
                                                />
                                              </IconButton>
                                            </div>
                                          </Tooltip>
                                        </div>
                                      </Box>
                                    )}
                                  </Box>
                                )
                              }
                              // })
                            }
                          })}
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </Grid>
                )
              }
            })}
          </Grid>
        </Grid>
      </Fragment>
    )
  }
}

Two.contextType = context

const mapStateToProps = state => {
  return {
    createdClient: state.users.createdClient,
    createdProducer: state.users.createdProducer,
    authenticatedUser: state.authentication.authenticatedUser,
    users: state.misc.users,
    activeCompany: state.companies.activeCompany,
    companyList: state.clients.companiesList,
    createdCompany: state.clients.createdClientCompany,
    companyClients: state.clients.companyClients,
    clientList: state.clients.clients,
    currentShoot: state.shoots.currentShoot,
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    null
  )
)(Two)
